

import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import { FaArrowUp, FaUsers, FaCalendarAlt } from 'react-icons/fa';
import logopng from '../assets/images/aiota.png';
import '../styles/HelpSupport.css';
import { useNavigate } from 'react-router-dom';

const HelpSupportPage = () => {
    const navigate = useNavigate();

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };
  // YouTube video IDs (replace with actual video IDs from the URLs)
  const tutorial1Url = 'https://www.youtube.com/embed/dQw4w9WgXcQ'; // Replace with actual video ID
  const tutorial2Url = 'https://www.youtube.com/embed/abc123XYZ';   // Replace with actual video ID
  const tutorial3Url = 'https://www.youtube.com/embed/xyz789ABC';   // Replace with actual video ID

  return (
    <>
      <section className="hero-fixed" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-content">
          <h1>All India Occupational Therapists' Association</h1>
        <div className="hero-buttons">
            <button className="glass-button" onClick={handleMemberLogin}>
              Member Login
            </button>            
            <button className="glass-button" onClick={handleEdcclogin}>Erganomic Certificate login</button>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content">
        <div className="content-container">
      <section className="content-section">
        <Container>
          <h1 className="section-titles">Help and Support</h1>

          <div className="tutorial-section">
            <div className="tutorial-card">
              <iframe
                src={tutorial1Url}
                title="Tutorial 1"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <p>Tutorial on how to reset password</p>
            </div>
            <div className="tutorial-card">
              <iframe
                src={tutorial2Url}
                title="Tutorial 2"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <p>Tutorial on how to make a payment</p>
            </div>
            <div className="tutorial-card">
              <iframe
                src={tutorial3Url}
                title="Tutorial 3"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <p>how to reset membership account</p>
            </div>
          </div>

          <div className="faq-section">
            <h3>Frequently Asked Questions</h3>

            <h4>REGARDING AIOTA MEMBERSHIP</h4>
            <ul>
              <li>
                <p>1. What are the payment options available while applying for AIOTA Life Membership?</p>
                <p>Account Name: All India Occupational Therapists Association (AIOTA) Bank: Central Bank of India Branch: Mumbai Central, Account Number: 8050020133 IFSC Code: CBIN0280879 costs Rupees 1500/- (including 18% GST) Membership registration. The amount must be transferred from the applicant to the bank account. The transaction details should be emailed to Dr. Satish Maslekar, Honorary Treasurer of AIOTA, at treasurer@aiota.org (Contact Number: 982244021) upon notification of your payment by the Treasurer. Your application will be processed accordingly.</p>
              </li>
             <li>
                <p>2. Will I get a hard copy of my AIOTA Life Membership certificate and ID card?</p>
                <p>Yes, you will get a hard copy of your AIOTA Life Membership certificate and ID card.</p>
              </li>
              <li>
                <p>3. How many days will it take to get my Life Membership certificate and ID card?</p>
                <p>It will take approximately 30-45 days to process and dispatch your certificate and ID card.</p>
              </li>
              <li>
                <p>4. I have lost my AIOTA Life Membership certificate. What do I do?</p>
                <p>Contact the Treasurer with proof of identity and request a duplicate certificate.</p>
              </li>
              <li>
                <p>5. I have lost my AIOTA Life Membership ID card. What do I do?</p>
                <p>Contact the Treasurer with proof of identity and request a duplicate ID card.</p>
              </li>
              <li>
                <p>6. How do I download the AIOTA Life Membership certificate and ID card online?</p>
                <p>Log in to the AIOTA portal and download from the member dashboard.</p>
              </li>
              <li>
                <p>7. What documents are required for AIOTA Life Membership registration?</p>
                <p>A completed application form and payment receipt are required.</p>
              </li>
              <li>
                <p>8. Can AIOTA Life Membership be taken by anyone who has a degree in Occupational Therapy?</p>
                <p>Yes, provided they meet the eligibility criteria set by AIOTA.</p>
              </li>
              <li>
                <p>9. What is the validity of AIOTA Life Membership?</p>
                <p>Lifetime validity, no renewal required.</p>
              </li>
              <li>
                <p>10. Will there be duplicate AIOTA ID if I lost it?</p>
                <p>Yes, a duplicate can be issued upon request with proper verification.</p>
              </li>
              <li>
                <p>11. How do I apply for AIOTA Life Membership?</p>
                <p>Submit an application form and payment through the AIOTA website.</p>
              </li>
              <li>
                <p>12. I have lost my payment details for AIOTA Life Membership. What should I do?</p>
                <p>Contact the Treasurer with transaction details for assistance.</p>
              </li>
            </ul>

            <h4>REGARDING AIOTA MEMBERSHIP RENEWAL</h4>
            <ul>
             <li>
                <p>2. Will I get a hard copy of my renewed AIOTA Life Membership certificate and ID card?</p>
                <p>Yes, upon successful renewal.</p>
              </li>
              <li>
                <p>3. How many days will it take to get my renewed AIOTA Life Membership certificate and ID card?</p>
                <p>Approximately 30-45 days after processing.</p>
              </li>
              <li>
                <p>4. How do I download the renewed AIOTA Membership certificate and ID card online?</p>
                <p>Log in to the AIOTA portal and download from the member dashboard.</p>
              </li>
              <li>
                <p>5. What documents are required for AIOTA Membership renewal?</p>
                <p>Renewal form and payment receipt.</p>
              </li>
              <li>
                <p>6. What is the validity of AIOTA Life Membership?</p>
                <p>Lifetime validity, no renewal required unless specified.</p>
              </li>
              <li>
                <p>7. What do I do if payment for AIOTA Membership renewal has failed or multiple payments have been made?</p>
                <p>Contact the Treasurer for refund or correction.</p>
              </li>
              <li>
                <p>8. Will there be a change in my membership number after I renew my AIOTA Membership?</p>
                <p>No, the membership number remains the same.</p>
              </li>
              <li>
                <p>9. How do I renew my AIOTA Life Membership?</p>
                <p>Submit a renewal form and payment through the AIOTA website.</p>
              </li>
            </ul>

            <h4>WFOT INDIVIDUAL MEMBERSHIP</h4>
            <ul>
            <li>
                <p>1. I am a member of AIOTA. Can I directly apply for WFOT Individual Membership?</p>
                <p>No, it can only be applied through AIOTA.</p>
              </li>
              <li>
                <p>2. What is the validity of WFOT Individual Membership?</p>
                <p>One year from the date of activation.</p>
              </li>
              <li>
                <p>3. How do I make payment for WFOT Individual Membership?</p>
                <p>Through AIOTA as per their guidelines.</p>
              </li>
              <li>
                <p>4. When can I apply for WFOT Individual Membership?</p>
                <p>During the application window announced by AIOTA.</p>
              </li>
              <li>
                <p>5. What are the fees for WFOT Individual Membership?</p>
                <p>Rupees 2500/- as specified by AIOTA.</p>
              </li>
              <li>
                <p>6. When does AIOTA apply for the WFOT Individual Membership? How long will it take for the membership to be activated?</p>
                <p>AIOTA applies annually in January; activation takes about 3 months.</p>
              </li>
              <li>
                <p>7. Will I receive any certificates or ID card for WFOT Membership?</p>
                <p>No, only a softcopy certificate will be provided.</p>
              </li>
              <li>
                <p>8. Whom can I contact for any queries or delays after applying for WFOT Individual Membership?</p>
                <p>Contact admin@wfot.org for assistance.</p>
              </li>
            </ul>
          </div>
        </Container>
      </section>
</div>
</div>
    </>
  );
};

export default HelpSupportPage;